import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import {
  popupStore,
  formatDate,
  ListItemBox,
  ListItemCont,
  ListElemText,
  userInfoStore,
  convertAmount,
  ListBoxItemImg,
  useTranslation,
  ListItemBoxRow,
  ListItemBoxText,
  ListItemBoxCell,
  applicationStore,
  ListItemBoxHeader,
  exchangeAmountByRate,
} from '@pascal/pascal-core';

import { doBetsStore } from '../../../store';
import { PopupTypes } from '../../../enums/popupTypes';
import { globalTranslationKeys } from '../../../enums';
import pfCheck from '../../../assets/images/core/pf-check.png';

export const BetHistoryItem = observer(({ bet }) => {
  const t = useTranslation();
  const { detectAndOpenCheckHashPopup } = popupStore;
  const { isDemo } = applicationStore;
  const { currencySymbolOrCode } = userInfoStore;
  const { setSelectedBetHistoryItem } = doBetsStore;

  const openCheckHash = useCallback(
    (bet) => {
      if (!isDemo) {
        setSelectedBetHistoryItem(bet);
        const selectedId = bet.id;
        detectAndOpenCheckHashPopup({ selectedId, name: PopupTypes.CheckHash, isFromBetHistory: true });
      }
    },
    [detectAndOpenCheckHashPopup, isDemo]
  );

  return bet.additionalParams.markets.map((additionalParam) => (
    <ListItemCont>
      <ListItemBox
        haveHover={!isDemo}
        name={bet.id}
        data={additionalParam}
        onClick={() => openCheckHash({ id: bet.id, ...additionalParam })}
      >
        <ListItemBoxHeader>
          <ListItemBoxCell size={'big'}>
            <ListItemBoxText size={'big'} text={`${t(globalTranslationKeys.RoundId)} ${bet.roundId}`} />
          </ListItemBoxCell>
          <ListItemBoxCell size={'small'}>
            <ListItemBoxText text={formatDate(bet.date)} size={'big'} />
          </ListItemBoxCell>
          {!isDemo && (
            <ListItemBoxCell size='small'>
              <ListBoxItemImg imageSrc={pfCheck} />
            </ListItemBoxCell>
          )}{' '}
        </ListItemBoxHeader>
        <ListItemBoxRow>
          <ListItemBoxCell size={'big'}>
            <ListItemBoxText size={'big'} text={`${t(globalTranslationKeys.Bet)}`} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText
              size={'big'}
              text={bet.freeBetId ? t('FREE_BET') : convertAmount(exchangeAmountByRate(bet).amount)}
            />
          </ListItemBoxCell>
        </ListItemBoxRow>
        <ListItemBoxRow>
          <ListItemBoxCell size={'big'}>
            <ListItemBoxText size={'big'} text={`${t(globalTranslationKeys.Odd)}`} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListElemText>x{additionalParam.odd}</ListElemText>
          </ListItemBoxCell>
        </ListItemBoxRow>
        <ListItemBoxRow>
          <ListItemBoxCell size={'big'}>
            <ListItemBoxText size={'big'} text={`${t(globalTranslationKeys.Win)}`} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText
              className={'win-color'}
              size={'big'}
              text={`${convertAmount(additionalParam.winAmount)} ${currencySymbolOrCode}`}
            />
          </ListItemBoxCell>
        </ListItemBoxRow>
      </ListItemBox>
    </ListItemCont>
  ));
});
